import { type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './Button';
import { DropdownMenu, type DropdownMenuItem } from './DropdownMenu';

export interface SplitButtonProps {
  label: string;
  icon?: ReactNode;
  items: DropdownMenuItem[];
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  disabled?: boolean;
  align?: 'left' | 'right';
}

export function SplitButton({
  label,
  icon,
  items,
  size = 'sm',
  variant = 'primary',
  disabled = false,
  align = 'right',
}: SplitButtonProps) {
  return (
    <DropdownMenu
      trigger={
        <Button
          size={size}
          variant={variant}
          disabled={disabled}
          leftIcon={icon}
          rightIcon={<ChevronDown className="h-4 w-4" />}
        >
          {label}
        </Button>
      }
      align={align}
      items={items}
    />
  );
}
